import { NumberType as NumberTypeFormatter } from "../core/formatters/number.formatter"
import { NumberType } from "./numbers.models"
import { numberFormatters } from "../core/formatters/number.formatter"

export interface NumberOptions {
    format: (price: number) => string
    color?: (price: number) => string
}

const numberColor = (price: number) => price > 0 ? 'var(--green-percentage)' : 'var(--coral)'

export const NumberOptionsMap = new Map<NumberType, NumberOptions>([
    [NumberType.change_total_7D_btc_etf_native,  {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.change_total_7D_eth_etf_native,  {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.last_total_etf_eth_usd,  {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.last_total_etf_btc_usd,  {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.change_total_7D_eth_absolute, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.ethereumPrice), 
        color: numberColor
    }],
    [NumberType.change_total_7D_btc_absolute, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.bitcoinPrice), 
        color: numberColor
    }],
    [NumberType.last_total_rwa_tvl_no_stablecoins, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.last_total_rwa_stablecoins_tvl, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.total_rwa_holders, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.number),
    }],
    [NumberType.total_rwa_stablecoins_holders, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.number),
    }],
    [NumberType.change_total_rwa_holders_30_days, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.change_total_rwa_tvl_no_stablecoins_30_days, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.change_total_rwa_stablecoins_holders_30_days, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.change_total_rwa_stablecoins_tvl_30_days, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.total_tvl_money_market_funds, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.total_tvl_money_market_funds_1Y, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price)
    }],
    [NumberType.total_tvl_private_credit_funds, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.total_tvl_private_credit_funds_1Y, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price)
    }],
    [NumberType.m2sl_latest, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.total_tvl_euros_stablecoins, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.percentage_stablecoins_vs_m2, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent)
    }],
    [NumberType.total_tvl_non_tokenized_money_market_fund, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.total_tvl_non_tokenized_money_market_fund_1Y, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price)
    }],
    [NumberType.total_tvl_non_tokenized_private_credit_fund, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.total_tvl_non_tokenized_private_credit_fund_1Y, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price)
    }],
    [NumberType.percentage_money_market_tokenized_vs_non_tokenized, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent)
    }],
    [NumberType.percentage_private_credit_tokenized_vs_non_tokenized, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent)
    }],
    [NumberType.perentage_money_market_tokenized_vs_non_tokenized_1Y, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent)
    }],
    [NumberType.perentage_private_credit_tokenized_vs_non_tokenized_1Y, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent)
    }],
    [NumberType.total_tradefi_assets, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.eth_price, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.eth_price_change_7d, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.eth_market_cap, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.eth_defi_tvl, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.eth_defi_tvl_7d_change_pct, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent),
        color: numberColor
    }],
    [NumberType.last_total_rwa_ethereum_stablecoins_tvl, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.price),
    }],
    [NumberType.change_total_rwa_ethereum_stablecoins_tvl_7d, {
        format: (number: number) => numberFormatters.defaultFormat(number, NumberTypeFormatter.percent)
    }]
])